<template>
    <div class="header profile">
      <ul class="nav navbar-nav navbar-right">
        <li v-if="!isAuthenticated" key="header-signin" @click="authenticate()">Sign in</li>
        <li v-if="isAuthenticated" key="header-signout" @click="signout()">Sign out</li>
      </ul>
    </div>
</template>

<script>
  import auth from "@/services/auth";

  export default {
    name: "profile",
    computed: {
      isAuthenticated: function() {
        return this.$store.getters.isAuthenticated;
      }
    },
    methods: {
      authenticate() {
        auth.authenticate();
      },
      signout() {
        this.$store.dispatch("signout").then(() => {
          auth.authenticate();
        });
      }
    }
  };
</script>

<style>
  .profile {
    margin-left: 10px;
    margin-right: 10px;
  }
  .header li {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile.vue